import React from "react";
import { Modal, ModalCloseButton, ModalContent, ModalOverlay, Box, Flex, Text, Button } from "@chakra-ui/react";

interface Props {
	isOpen: boolean;
	onClose: () => void;

	focusName?: string;
	handleConfirmation: () => void;
}

export function ConfirmEndFocusModal(props: Props): JSX.Element {
	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} size="sm">
			<ModalOverlay bg="rgba(0, 0, 0, 0.68)" />
			<ModalContent>
				<Box>
					<ModalCloseButton float={"right"} my={-10} mx={-10} />
				</Box>
				<Flex direction={"column"} gap={24}>
					<Text fontWeight={500} fontSize={"22px"} color={"#051839"}>
						End Focus
					</Text>
					<Text fontSize={"14px"} color={"#42526E"} lineHeight={"20px"}>
						You are about to remove the last student from the active Focus. This action will automatically end the{" "}
						{props.focusName && `"${props.focusName}"`} focus for all students.
					</Text>
					<Text fontWeight={500} color={"#051839"}>
						Are you sure you want to end the {props.focusName && `"${props.focusName}"`} focus?
					</Text>
				</Flex>
				<Box mt={30}>
					<Button
						float={"right"}
						onClick={() => {
							props.handleConfirmation();
							props.onClose();
						}}
					>
						End Focus
					</Button>
				</Box>
			</ModalContent>
		</Modal>
	);
}
